<template>
	<div>
		<div :class="['box', status]">
			<div class="columns is-vcentered is-marginless">
				<div class="column is-narrow">
					<dc-icon
						library="fas"
						icon="file-pdf"
						size="lg"
						no-margin
					/>
				</div>
				<div class="column">
					<form-text placeholder="File title" :name="titleName" />
				</div>
				<div class="column is-narrow">
					<dc-icon class="move-icon" icon="bars" size="lg" />
					<span @click="onDelete">
						<dc-icon
							class="delete-icon"
							icon="trash-alt"
							size="lg"
							no-margin
						/>
					</span>
				</div>
			</div>
			<p class="file-message" :class="{ 'has-text-danger': !title }">
				{{ filemessage }}
			</p>
		</div>
	</div>
</template>

<script>
import format from "date-fns/format";
import fieldMixin from "@lab/utils/fieldMixin";
import FormText from "@shared/form-v1/FormText";

export default {
	components: { FormText },
	mixins: [fieldMixin],
	props: {
		onDelete: {
			type: Function,
			required: true
		}
	},
	computed: {
		titleName() {
			return `${this.name}.title`;
		},
		created() {
			return format(new Date(this.value.created), "d MMM yyyy");
		},
		status() {
			return this.value.status;
		},
		filemessage() {
			return this.title != ""
				? this.status === "active"
					? `Uploaded ${this.created}`
					: `Uploaded file has not been saved`
				: `Title is required`;
		},
		title() {
			return this.value.title;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@lab/tokens/variables";

.move-icon {
	&:hover {
		cursor: grab;
		.sortable-chosen &,
		.sortable-ghost & {
			cursor: grabbing;
		}
	}
}
.delete-icon {
	color: lighten($color: $colour-dark-grey, $amount: 50%);
	&:hover {
		color: $colour-dark-grey;
		cursor: pointer;
	}
}
.file-message {
	font-size: 0.9rem;
	padding-left: 3.5rem;
}
.box {
	margin-bottom: 1.5rem;
	padding: 1rem;

	&.uploaded {
		background-color: fade-out($color: #f5d218, $amount: 0.8);
		color: $colour-dark-grey;
	}
}
</style>
